export enum DATA_TYPE {
  FLOAT = 'FLOAT',
  FLOAT64 = 'FLOAT64',
  BYTES = 'BYTES',
  BOOL = 'BOOL',
  BOOLEAN = 'BOOLEAN',
  INTEGER = 'INTEGER',
  INT64 = 'INT64',
  STRING = 'STRING',
  INT16 = 'INT16',
  UINT16 = 'UINT16',
  INT32 = 'INT32',
  UINT32 = 'UINT32',
  TIMESTAMP = 'TIMESTAMP'
}
